export default [
  {
    id: 1,
    slug: 'kpn',
    title: 'Wejo',
    src: '/img/projects/heineken.png',
    role: 'Developer',
    url: 'https://www.kpn.nl',
    text1: true,
    text2: true,
    text3: true
  },
  {
    id: 2,
    slug: 'kvk',
    title: 'Het',
    src: '/img/projects/abn_amro.png',
    role: 'Developer',
    url: 'https://www.kvk.nl',
    text1: true,
    text2: false,
    text3: false
  },
  {
    id: 3,
    slug: 'campina.png',
    title: 'werkt gewoon',
    src: '/img/projects/campina.png',
    role: 'Developer',
    url: 'https://www.vanmeijel.nl',
    text1: true,
    text2: false,
    text3: false
  },
  {
    id: 4,
    slug: 'servicehouse',
    title: 'voor',
    src: '/img/projects/servicehouse.png',
    role: 'Developer',
    url: 'https://www.servicehouse.nl',
    text1: true,
    text2: false,
    text3: false
  },
  {
    id: 5,
    slug: 'royal_haskoningdhv',
    title: 'een keer',
    src: '/img/projects/haskoning.png',
    role: 'Developer',
    url: 'https://www.servicehouse.nl',
    text1: true,
    text2: false,
    text3: false
  }
]
